import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'

import { currencyFormatter } from '../../utils'

import { ProfitCellProps } from './types'

export const ProfitCell: FC<ProfitCellProps> = ({ value, currency }) => {
  const { palette } = useTheme()
  const profit = parseFloat(value.replace(/[^0-9.-]/g, ''))
  const textColor = profit < 0 ? palette.red[400] : profit > 0 ? palette.green[400] : ''

  return (
    <Typography fontWeight={700} color={textColor} noWrap>
      {currencyFormatter(currency, Number(value))}
    </Typography>
  )
}
